export enum BadgeState {
    ACTIVE,
    RED_LIST,
    BLACK_LIST
}
